import { FC } from 'react';
// components
import SandCoatingFormulation from 'components/main/SandCoatingFormulation/Edit';

const EditSandCoatingFormulation: FC = () => <SandCoatingFormulation />;

export default EditSandCoatingFormulation;
